import React, { useState } from 'react';
import { LoginForm } from './LoginForm';
import { HashRouter, Route, Routes } from 'react-router-dom';
import PasswordReset from './PasswordReset';
import CustomSnackbar from '../../components/CustomSnackbar';

const AuthenticationForm = () => {
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>('');
  const [initialEmail] = useState(() => new URLSearchParams(window.location.search).get('email') || '');
  const [initialStage] = useState(() => (initialEmail ? ('resetPassword' as const) : undefined));

  const path = window.location.pathname;
  const hash = window.location.hash;
  const authSlug = window.authenticationPageSlug || 'authentication';

  const showSnackbar = (message: string) => {
    setSnackbarMessage(message);
    setIsSnackbarOpen(true);
  };

  // if url is baseurl/authSlug/password-reset?token=...
  const isPasswordResetPage = path.includes(authSlug) && hash.length > 0;

  const renderFormElement = () => {
    if (isPasswordResetPage) {
      return (
        <HashRouter>
          <Routes>
            <Route path="/password-reset" element={<PasswordReset showSnackbar={showSnackbar} />} />
          </Routes>
        </HashRouter>
      );
    } else {
      return (
        <LoginForm
          showSnackbar={showSnackbar}
          hasDynamicTitle
          initialStage={initialStage}
          initialEmail={initialEmail}
        />
      );
    }
  };

  return (
    <>
      <CustomSnackbar open={isSnackbarOpen} message={snackbarMessage} onClose={() => setIsSnackbarOpen(false)} />

      <div className="authentication__form">{renderFormElement()}</div>
    </>
  );
};

export default AuthenticationForm;
